export enum KakaotalkTemplateUsageEnum {
  advisor = 'advisor',
  bot = 'bot',
}
